export var compKey = 'popover-select';
//# sourceMappingURL=key.js.map